import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './utils/firebaseConfig';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Employees from './components/Employees';
import Managers from './components/Managers';
import Locations from './components/Locations';
import { DataProvider } from './components/DataContext';
import Frame from './components/Frame';

const AppStatus = ({ children, role = 'status' }) => (
  <main className="app-status" role={role} aria-live="polite">{children}</main>
);

const AuthenticatedRoutes = () => (
  <DataProvider>
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<Frame><Dashboard /></Frame>} />
      <Route path="/employees" element={<Frame><Employees /></Frame>} />
      <Route path="/managers" element={<Frame managerOnly><Managers /></Frame>} />
      <Route path="/locations" element={<Frame managerOnly locationsOnly><Locations /></Frame>} />
      <Route path="/sandbox" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  </DataProvider>
);

function App() {
  const [user, loading, error] = useAuthState(auth);
  return (
    <Router>
      {loading ? <AppStatus>Loading your account…</AppStatus> : error ? (
        <AppStatus role="alert">Unable to verify your session. Refresh and try again.</AppStatus>
      ) : user ? <AuthenticatedRoutes /> : (
        <Routes><Route path="/" element={<Login />} /><Route path="*" element={<Navigate to="/" replace />} /></Routes>
      )}
    </Router>
  );
}

export default App;
